<template>
  <div>
    <v-container class="content-wrapper" fluid id="add-patent-tab">
      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-row align="center" class="mb-10">
              <v-col cols="12" md="auto">
                <v-btn
                  depressed
                  rounded
                  medium
                  color="primary200"
                  class="white--text font-weight-bold"
                  :to="{ name: 'Patents' }"
                >
                  <v-icon color="black" small class="mr-2">
                    mdi-arrow-left
                  </v-icon>
                  Back to your Patents
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" md="6" class="justify-end d-flex pt-5">
                <v-btn-toggle v-model="toggleVisibility" rounded mandatory>
                  <v-tooltip bottom color="neutral">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" value="published" @click="publishPatent">
                        {{ $t('public') }}
                        <v-icon class="pl-2">mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('tooltip-public') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom color="neutral">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" value="unpublished" @click="unpublishPatent">
                        {{ $t('private') }}
                        <v-icon class="pl-2">mdi-information-outline</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('tooltip-private') }}</span>
                  </v-tooltip>
                </v-btn-toggle>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6" class="neutral--text text-semi-bold mb-4">
                {{ $t('add-patent-info') }}
              </v-col>
            </v-row>
            <div>
              <h5>
                {{ $t('your-progress') }}
              </h5>
              <label class="text-bold primary300--text"
                >{{ tab + 1 }}/{{ totalTabs }} {{ $t('to-complete') }}</label
              >
              <v-progress-linear
                v-model="progress"
                color="primary300"
                id="equipment-progress-bar"
                class="mb-4 mt-4"
                height="25"
              ></v-progress-linear>
            </div>

            <!-- Tabs for create patent -->
            <v-tabs
              v-model="tab"
              show-arrows
              active-class="primary200--text"
              class="disable-transition"
            >
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ $t('basic') }}</v-tab>
              <v-tab>{{ $t('detailed') }}</v-tab>
              <v-tab>{{ $t('classification') }}</v-tab>
              <v-tab>{{ $t('contact') }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item :transition="false" :reverse-transition="false" :key="0">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <PatentBasicInfo
                      @tab="changeTab"
                      @patentBasicInfo="handlePatentBasicInfo"
                    ></PatentBasicInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="1">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <PatentDetailedInfo
                      @tab="changeTab"
                      @patentDetailedInfo="handlePatentDetailedInfo"
                    ></PatentDetailedInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="2">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <PatentClassificationInfo
                      @tab="changeTab"
                      @patentClassificationInfo="handlePatentClassificationInfo"
                    ></PatentClassificationInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="3">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <PatentContactInfo
                      @tab="changeTab"
                      @patentContactInfo="handlePatentContactInfo"
                    ></PatentContactInfo>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center mb-10" v-if="dataForPayload">
                  <v-btn
                    depressed
                    rounded
                    x-large
                    width="450px"
                    color="black"
                    @click="submit"
                    class="white--text font-weight-bold"
                    >{{ $t('submit') }}
                  </v-btn>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PatentBasicInfo from './PatentBasicInfo.vue';
import PatentDetailedInfo from './PatentDetailedInfo.vue';
import PatentClassificationInfo from './PatentClassificationInfo.vue';
import PatentContactInfo from './PatentContactInfo.vue';
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'AddPatent',
  mixins: [util],
  components: { PatentBasicInfo, PatentDetailedInfo, PatentClassificationInfo, PatentContactInfo },
  data() {
    return {
      toggleVisibility: 'published',
      tab: null,
      totalTabs: 4,
      public: true,
      patentBasicInfo: Object,
      patentDetailedInfo: Object,
      patentClassificationInfo: Object,
      patentContactInfo: Object,
    };
  },
  created() {
    if (this.isFirstTime() && this.$store.getters.roles === 'provider') {
      const marketplaceServicesViewAll = true;
      const selectedCatalogue = 'Browse the Catalogue of Services';
      let routePath = '';
      routePath = '/marketplace/services';
      this.$router.push({
        path: routePath,
        query: { selectedCatalogue, marketplaceServicesViewAll },
      });
    }
  },
  computed: {
    progress() {
      return ((this.tab + 1) / this.totalTabs) * 100;
    },
    dataForPayload() {
      return Object.keys(this.patentContactInfo).length > 0;
    },
  },
  methods: {
    publishPatent() {
      this.public = true;
    },
    unpublishPatent() {
      this.public = false;
    },
    changeTab(childTab) {
      console.log('Tab changed');

      this.tab = childTab;
    },
    handlePatentBasicInfo(data) {
      this.patentBasicInfo = data;
    },
    handlePatentDetailedInfo(data) {
      this.patentDetailedInfo = data;
    },
    handlePatentClassificationInfo(data) {
      this.patentClassificationInfo = data;
    },
    handlePatentContactInfo(data) {
      this.patentContactInfo = data;
    },
    submit() {
      const payload = {
        ...this.patentBasicInfo,
        ...this.patentDetailedInfo,
        ...this.patentClassificationInfo,
        ...this.patentContactInfo,
        published: this.public,
      };

      console.log('Payload Body', payload);

      this.axios
        .post('/api/v1/patent', payload)
        .then(response => {
          console.log('Success:', response.data);
          EventBus.$emit('snackbar', {
            text: 'Patent Created Successfully',
          });
          this.$router.push({ name: 'Patents' });
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
  },
};
</script>
